import request from '@/utils/request';
import qs from 'qs';
import { BASE_URL } from '@/utils/global';

export interface LoginData {
  userName: string;
  password: string;
}

export function login(data: any) {
  return request.post(`${BASE_URL.scmServer}/api/admin/account/login.ac`, data);
}

export function logout() {
  // todo
}

// 获取验证码
export function getSmsByM(data: any) {
  return request({
    url: `${BASE_URL.webServer}/getSmsByM.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
}
// 验证码注册
export function validateSmsCode(data: any) {
  return request({
    url: `${BASE_URL.webServer}/validateSmsCode.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
}
// 完成注册
export function register(data: any) {
  return request({
    url: `${BASE_URL.webServer}/register.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
}
// 完成注册
export function updateCompanyInfo(data: any, params: any) {
  return request({
    url: `${BASE_URL.webServer}/updateCompanyInfo.ac`,
    method: 'post',
    params,
    data,
  });
}
// 忘记密码-获取图片验证码
export function captchaImage(params: any) {
  return request({
    url: `${BASE_URL.webServer}/captchaImage.ac`,
    method: 'get',
    params,
  });
}
// 忘记密码-通过图片验证码获取手机短信验证码
export function rePassSMSByM(data: any, params: any) {
  return request({
    url: `${BASE_URL.webServer}/rePassSMSByM.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
    params,
  });
}
// 忘记密码-获取验证码
export function rePassValiSmsCode(data: any) {
  return request({
    url: `${BASE_URL.webServer}/rePassValiSmsCode.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
}
// 忘记密码-生成新密码
export function resetPass(data: any) {
  return request({
    url: `${BASE_URL.webServer}/resetPass.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data),
  });
}
// 体验账号登录
export function expLoginForMobile(data: any) {
  return request({
    url: `${BASE_URL.webServer}/admin/expLoginForMobile.ac`,
    method: 'post',
    data,
  });
}
// 获取行业数据
export function getCommonIndustry() {
  return request({
    url: `${BASE_URL.cloudServer}/crmf/is/merchantCertificate/getCommonIndustry.ac`,
    method: 'post',
  });
}

// 获取用户配置
export function queryUserConfigList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/system/userConfig/queryUserConfigList.ac`,
    method: 'post',
    data: {
      // device: 2,
      ...data,
    },
  });
}

// 保存用户配置
export function saveUserConfig(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/system/userConfig/saveUserConfig.ac`,
    method: 'post',
    data,
  });
}

// 修改公司信息
export function updateCompanyContent(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/company/update.ac`,
    method: 'post',
    data,
  });
}

// 获取热更信息
export function getAppPatchVersion(params: any) {
  return request({
    url: `${BASE_URL.cloudServer}/push/config/scm/getAppPatchVersion.ac`,
    method: 'get',
    params,
  });
}

// 注销用户
export function userDelete(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/delete.ac`,
    method: 'post',
    data,
  });
}

export function getOrderSignature(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/share/getOrderSignature.ac`,
    method: 'post',
    params,
  });
}

// 获取公司信息（无权限校验）
export function getCurrentUser() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/account/user/getCurrentUser.ac`,
    method: 'post',
  });
}

// 查询所有系统配置
export function queryCompanyConfigList() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/system/companyConfig/queryCompanyConfigList.ac`,
    method: 'post',
    noErrorToast: true,
  });
}

// 保存系统配置
export function saveCompanyConfig(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/system/companyConfig/saveCompanyConfig.ac`,
    method: 'post',
    data,
  });
}

// 保存系统配置，根据configKey校验权限
export function saveCompanyConfigAdminByConfigKey(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/system/companyConfig/saveCompanyConfigAdminByConfigKey.ac`,
    method: 'post',
    data,
  });
}

// 获取列表tab的用户配置
export function listTabByConfigKey(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/customField/listByConfigKey.ac`,
    method: 'post',
    params,
  });
}

// 获取全部tab
export const listAllTab = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tab/listAllTab.ac`,
    method: 'post',
    params,
  });
};
// 保存tab
export const saveTab = (data: any, params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tab/save.ac`,
    method: 'post',
    data,
    params,
  });
};
// 保存tab
export const resetTab = (params: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tab/reset.ac`,
    method: 'post',
    params,
  });
};

// 重置流水号
export function resetSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/serialnumber/reset.ac`,
    method: 'post',
    data,
  });
}

// 商品字段关联映射关系
export function goodsSyncField(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/thirdparty/goodsSyncField/queryList.ac`,
    method: 'post',
    data,
  });
}
// 聚水潭匹配字段可选值-获取
export function listSelectField(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/thirdparty/goodsSyncField/listSelectField.ac`,
    method: 'post',
    data,
  });
}
// 聚水潭匹配字段可选值-保存
export function listSaveField(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/thirdparty/goodsSyncField/saveList.ac`,
    method: 'post',
    data,
  });
}
